// Libs
import React from "react";

// Style
import { ActiveFilterButton, IconClose, Content } from "./ActiveFilterStyle";

// Images
import iconClose from "../../../images/close-icon.svg";

const ActiveFilter = ({ label, onClick, children, ...props }) => {
  return (
    <ActiveFilterButton onClick={() => onClick()} {...props}>
      <Content>
        {label && <span>{label} </span>}
        <strong>{children}</strong>
        <IconClose src={iconClose} alt="close" />
      </Content>
    </ActiveFilterButton>
  );
};

export default ActiveFilter;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/activeFilters/ActiveFilter.js